var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div ng-if=\"$ctrl.state === 'loading'\" style=\"position: relative\" class=\"loading\"> <span style=\"position: relative; top: 0\" class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></span> </div> <div ng-if=\"$ctrl.state === 'ready'\" ng-repeat=\"week in $ctrl.weeks\" class=\"schedule-container\"> <winres-schedule-week days=\"week.days\" on-click=\"$ctrl.openModal(day, item)\"></winres-schedule-week> </div> <div ng-if=\"$ctrl.state === 'error'\"> <span class=\"glyphicon glyphicon-alert\"></span>\n{{ $ctrl.error }} </div> </web-component>";
var id1="winresEventTickets.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresEventTickets/winresEventTickets.html
// module id = 302
// module chunks = 2